import { Injectable } from '@angular/core';
import { EventAction, LockDetailsWithOwnerModel } from '../lockvue-ng-sdk';
import { LockDetailsUIModel } from '../models/LockDetailsWithPermissionModel';
import { DateFilterService } from './date-filter.service';
import { LockvueConfigProviderService } from './lockvue-config-provider.service';

@Injectable({
  providedIn: 'root',
})
export class TableSettingsUtilService {
  constructor(
    private configProvider: LockvueConfigProviderService,
    private dateFilterService: DateFilterService,
  ) {}

  getNumLocks(
    lockType: string,
    _locks: LockDetailsUIModel[] | LockDetailsWithOwnerModel[],
  ): number {
    let count = 0;
    if (_locks && _locks.length > 0) {
      _locks.forEach(l => (l.LockType === lockType ? ++count : false));
    }
    return count;
  }

  getLockManufacturerList(_locks: LockDetailsUIModel[] | LockDetailsWithOwnerModel[]) {
    const lockManufacturersList = [];

    const _lockTypes = this.configProvider.getLockTypes();

    _lockTypes.forEach(lockType =>
      lockManufacturersList.push({
        value: lockType.manufacturer,
        title: lockType.manufacturer + ' (' + this.getNumLocks(lockType.manufacturer, _locks) + ')',
      }),
    );
    return lockManufacturersList;
  }

  getLockSubtypes(_locks: LockDetailsUIModel[] | LockDetailsWithOwnerModel[]) {
    const lockSubtypes = {};
    if (_locks && _locks.length > 0) {
      _locks.forEach(l => {
        if (!lockSubtypes[l.Subtype]) {
          lockSubtypes[l.Subtype] = 0;
        }
        lockSubtypes[l.Subtype]++;
      });
    }

    const lockSubtypesFilter = [];
    for (const property in lockSubtypes) {
      if (lockSubtypes.hasOwnProperty(property)) {
        lockSubtypesFilter.push({
          value: property,
          title: property + ' (' + lockSubtypes[property] + ')',
        });
      }
    }
    return lockSubtypesFilter;
  }

  getExpiresOnFilterList() {
    const _expiresOnFilterItems = [];
    const filterItems = this.dateFilterService.getFilters('Unknown');
    filterItems.forEach(item => {
      _expiresOnFilterItems.push({ value: item, title: item });
    });
    return _expiresOnFilterItems;
  }

  getActionFilters() {
    return [
      { value: 'All_Unlocks', title: 'All Unlock Events' },
      { value: 'All_Permissions', title: 'All Permission Events' },
      { value: 'All_KeyRack', title: 'All KeyRack Events' },
      { value: EventAction.Request, title: 'Request' },
      { value: EventAction.Unlocked, title: 'Unlocked' },
      {
        value: EventAction.ShackleRemoved,
        title: 'Shackle Removed',
      },
      { value: EventAction.Locked, title: 'Locked' },
      { value: EventAction.Battery, title: 'Battery' },
      {
        value: EventAction.Added,
        title: 'Lock Activation',
      },
      { value: EventAction.Created, title: 'Created' },
      { value: EventAction.Deleted, title: 'Deleted' },

      {
        value: EventAction.LockStatus,
        title: 'Lock Status',
      },
      {
        value: EventAction.Removed,
        title: 'Lock Deactivation',
      },
      {
        value: EventAction.Granted,
        title: 'Permission Granted',
      },
      {
        value: EventAction.Revoked,
        title: 'Permission Revoked',
      },
      {
        value: EventAction.Modified,
        title: 'Lock Details Modified',
      },
      {
        value: EventAction.Heartbeat,
        title: 'Heartbeat',
      },
      {
        value: EventAction.PegRemoved,
        title: 'Peg Removed',
      },
      {
        value: EventAction.PegReturned,
        title: 'Peg Returned',
      },
      {
        value: EventAction.PegUnlocked,
        title: 'Peg Unlocked',
      },
      {
        value: EventAction.DoorUnlocked,
        title: 'Door Unlocked',
      },
      {
        value: EventAction.UnlockAll,
        title: 'Unlock All',
      },
    ];
  }

  activityActionFilterFunction(cell, search) {
    if (!search) return true;
    if (search === 'All_Unlocks') {
      return (
        EventAction.Unlocked === cell ||
        EventAction.ShackleRemoved === cell ||
        EventAction.Locked === cell ||
        EventAction.Battery === cell
      );
    }
    if (search === 'All_Permissions') {
      return EventAction.Granted === cell || EventAction.Revoked === cell;
    }
    if (search === 'All_KeyRack') {
      return (
        EventAction.Heartbeat === cell ||
        EventAction.PegRemoved === cell ||
        EventAction.PegReturned === cell ||
        EventAction.PegUnlocked === cell ||
        EventAction.UnlockAll === cell ||
        EventAction.DoorUnlocked === cell
      );
    }
    return search === cell;
  }

  hubAvailableLocksFilterFunction(cell, search): boolean {
    return cell.length.toString().includes(search);
  }

  groupNameFilterFunction(cell, search): boolean {
    return cell.Name?.toLowerCase().includes(search);
  }
}
